// extracted by mini-css-extract-plugin
export var noSpinners = "_sh-6";
export var percentageInput = "_sh-7";
export var variantColor1 = "_sh-0";
export var variantColor2 = "_sh-1";
export var variantColor3 = "_sh-2";
export var variantColor4 = "_sh-3";
export var variantColor5 = "_sh-4";
export var variantColor6 = "_sh-5";